import Loader from '@/components/Loader';
import Constants from '@/Constants';
import { ApplicationState } from '@/store';
import { closeModal } from '@/store/common/actions';
import React from 'react';
import Modal from 'react-bootstrap/esm/Modal';
import { useDispatch, useSelector } from 'react-redux';
import './styles.scss';

interface Props {
    loading: boolean;
}

const CouldNotInactivateCategoryModal: React.FC<Props> = ({ loading }: Props) => {
    const { strings } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
    }));
    const dispatch = useDispatch();

    const dismissModalHandler = () => {
        dispatch(closeModal(Constants.modal.COULD_NOT_INACTIVATE_CATEGORY_MODAL));
    };

    return (
        <Modal.Body className="body-content">
            <div className="could-not-inactivate-category-modal-container">
                {loading ? (
                    <Loader />
                ) : (
                    <>
                        <div className="header">
                            <i className="material-icons-outlined align-middle warning-amber">warning_amber</i>
                            <i className="material-icons-outlined align-middle close-icon" onClick={dismissModalHandler} role="button">
                                {Constants.icons.CLOSE}
                            </i>
                        </div>
                        <div className="modal-title">{strings.CATEGORY_MANAGEMENT_COULD_NOT_INACTIVATE_CATEGORY_TITLE}</div>
                        <div className="modal-description">{strings.CATEGORY_MANAGEMENT_COULD_NOT_INACTIVATE_CATEGORY_MSG}</div>
                    </>
                )}
            </div>
        </Modal.Body>
    );
};

export default CouldNotInactivateCategoryModal;
